import React from "react";
import { motion } from "framer-motion";
import englishWork from "../../../Images/coursecard_images/englishmain.jpg";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Nav from "../../../Nav";
import image3 from "../../../Images/coursecard_images/englishwork_1.jpg";
import image1 from "../../../Images/coursecard_images/englishwork_2.jpg";
import image2 from "../../../Images/coursecard_images/englishwork_3.jpg";

const EnglishAtWork = () => {
  return (
    <>
      <motion.div
        className="p-5 font-sans bg-gray-100 h-4/5 mt-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Page Title */}
        <h1 className="text-4xl font-extrabold text-gray-600 text-center mb-8">
          English At Work
        </h1>

        
      </motion.div>

      <Nav />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            py: 5,
            fontFamily: "Arial, sans-serif",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${englishWork})`,
              backgroundSize: "cover",
              py: 10,
              textAlign: "center",
              color: "#fff",
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#fff",
                }}
              >
                English At Work
              </Typography>
            </Container>
          </Box>

          <Container
            maxWidth="lg"
            sx={{ backgroundColor: "#ffffff", p: 5, borderRadius: 2, mt: -8 }}
          >
            <Grid container spacing={5} alignItems="flex-start" mb={10}>
              <Grid item xs={12} lg={6}>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  Are your work and career important to you? Whether it's your
                  job or career that matters to you, wouldn't you want to gain
                  that extra edge over your peers?
                </Typography>
                <Typography
                  variant="body1"
                  paragraph
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: 1.6,
                    color: "#6b778c",
                  }}
                >
                  <b>English at work will enable you to:</b>
                </Typography>
                <List>
                  {[
                    "<u><i>Understanding native speakers</i></u> easier ",
                    "<u>Focus on your training at work</u> and stop worrying about the language",
                    "<u><i>Deliver your presentations in English</i></u> just the way you wanted",
                    "<u><i>Build your confidence</i></u>",
                    "Take part in seminars and workshops & <u><i>understand other participants</i></u>",
                    "<u><i>''Remove'' your old speaking mistakes</i></u>",
                    "<u><i>Distinguish the sounds </i></u>in English and understand your coworkers.",
                    "<u><i>Work effectively</i></u> and deliver results at work ",
                  ].map((challenge, index) => (
                    <ListItem key={index}>
                      <CheckCircle color="primary" sx={{ mr: 2 }} />
                      <ListItemText
                        primary={
                          <Typography
                            dangerouslySetInnerHTML={{ __html: challenge }}
                          />
                        }
                        primaryTypographyProps={{
                          sx: { fontFamily: "Arial, sans-serif" },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} lg={6}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={englishWork}
                    alt="Fresh Start"
                    sx={{ borderRadius: 2 }}
                  />
                </motion.div>
              </Grid>
            </Grid>
            <Grid item xs={12} lg={10}>
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardMedia
                  component="img"
                  image={image2}
                  alt="Fresh Start"
                  sx={{
                    borderRadius: 2,
                    width: "100%",
                    paddingBottom: "19px",
                  }}
                />
              </motion.div>
            </Grid>
            <CardContent>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                Below are typical examples of employees in need of English in
                their workplace.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>
                  <i>Marek, the Czech Republic</i>
                </u>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                I work in HR (Human Resources), so I am involved in tasks such
                as creating contracts, making amendments, and managing employee
                profiles. My communication in English is limited to work, and it
                mostly involves emailing and occasional meetings. I don’t speak
                English often, so I can’t express myself well during meetings. I
                wish to improve my speaking.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>
                  <i>Pierre, France</i>
                </u>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                I was recently hired as a product manager, and I need to speak
                to our international clients by phone. I participate in online
                conferences, and I need to present my ideas, but I struggle to
                express myself in English. Writing feels easier for me than
                speaking. I have difficulty understanding native speakers
                because they speak so fast, and I miss many parts of what they
                say. Our latest project is with our German partners, but we can
                only communicate in English.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>
                  <i>Maria, Germany</i>
                </u>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                I use English daily in our meetings, for reading our reports,
                and for emailing. I make many phone calls in English. My clients
                are located in the UK and the Republic of Ireland, so at least I
                get the chance to speak English regularly. However, I make too
                many grammar mistakes when I speak quickly. I can’t understand
                British accents, and I often confuse words that sound similar
                but mean something completely different. I struggle to
                understand many English phrases, which often leaves me confused.
                My goal is to have more conversations in English because I want
                to expand my vocabulary. I have a big problem because I can’t
                find the right words when discussing our projects.
              </Typography>

              <Grid item xs={12} lg={11} container spacing={2}>
                <Grid item xs={6} paddingBottom={"20px"}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <CardMedia
                      component="img"
                      image={image1}
                      alt="Fresh Start"
                      sx={{ borderRadius: 2 }}
                    />
                  </motion.div>
                </Grid>
                <Grid item xs={6}>
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                  >
                    <CardMedia
                      component="img"
                      image={image3}
                      alt="Fresh Start"
                      sx={{ borderRadius: 2 }}
                    />
                  </motion.div>
                </Grid>
              </Grid>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <i>
                  <b>
                    Ask yourself - How can English help me improve my
                    performance at work?
                  </b>
                </i>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                If you are in a similar situation and need to polish your
                English to express yourself and produce great results as an
                effective team member at work then you’re in the right place.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                The better you speak, communicate, and understand others around
                you in English the better chances you stand of building the
                career you deserve.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                You can{" "}
                <i>
                  <b>start working on yourself</b>
                </i>{" "}
                by making a decision that could transform your life and bring
                about the positive change you’re hoping for.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <i>
                  <u>
                    Start working on your fluent English and ultimately your
                    dreams today,
                  </u>
                </i>{" "}
                and don’t leave them for tomorrow.
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <b>
                  <u>
                    Your transformation is around the corner but you need to
                    seize the opportunity.
                  </u>
                </b>
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <b>
                  <u>English at work </u>
                </b>
                can help you master the{" "}
                <b>
                  <u>business English vocabulary,</u>
                </b>{" "}
                learn the most typical{" "}
                <b>
                  <i>
                    expressions and phrases used in the modern corporate
                    environment,
                  </i>
                </b>{" "}
                and guide you towards fluent speaking. reach your goals by
                putting you on the right track
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <i>
                  <b>Your objective in English </b>
                </i>
                is our priority and we will do our best to assist you. Don’t be
                scared of communicating with your co-workers or business
                partners ever again. Show your
                <b>
                  <i> confidence in spoken and written English </i>
                </b>
                and express your professional opinion clearly. Make yourself
                understood and{" "}
                <b>
                  <i> speak English eloquently</i>
                </b>
                .
              </Typography>
              <Typography
                variant="body1"
                paragraph
                sx={{
                  fontFamily: "Arial, sans-serif",
                  lineHeight: 1.6,
                  color: "#6b778c",
                }}
              >
                <u>Contact us</u> anytime and let us know about your goals in
                English.
              </Typography>
            </CardContent>
            <div className="flex flex-col md:flex-row gap-6 items-center justify-center">
          {/* Card 1: Course Details */}
          <div className="w-full md:w-1/2 bg-green-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Self-studying Course
            </h2>
            <p className="text-gray-700 mb-2">
              <strong>Type of course:</strong> Self-studying course
            </p>
            <p className="text-gray-700 mb-2">
              <strong>The course contains:</strong> 69 Business English PDF
              Lessons
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Price:</strong> $240
            </p>
          </div>

          {/* Card 2: Bundle Pricing */}
          <div className="w-full md:w-1/2 bg-blue-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Bundle Price Option
            </h2>

            <p className="italic text-gray-600 mt-4 text-center">
              $0 / 1 year access / Value: $240
            </p>
          </div>
        </div>
            <Box textAlign="center" mb={10} mt={2}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ borderRadius: 5, px: 5, py: 2 }}
              >
                Join Now
              </Button>
            </Box>
          </Container>
        </Box>
      </motion.div>
    </>
  );
};

export default EnglishAtWork;
